import MuiTypography from '@mui/material/Typography';
import moment from 'moment/moment';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import { Box, Stack, Chip } from '@mui/material';
import MuiChip from '@mui/material/Chip';
import _ from 'lodash';
import { getColorConfig, getIcon, RegistrationStatus } from './Data.conf';
import Tooltip from '@mui/material/Tooltip';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: {
      by: 'yacht_name',
      direction: 'asc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'attributes.id',
      key: 'id',
      label: 'ID',
      width: 50,
    },
    {
      id: 'attributes.yacht_name',
      key: 'yacht_name',
      sort_key: 'yacht_name',
      sortable: true,
      label: 'Yacht Name',
    },
    {
      id: 'attributes.yacht_type',
      key: 'yacht_type',
      sort_key: 'yacht_type',
      sortable: true,
      label: 'Yacht Type',
    },
    {
      id: 'attributes.registry_type',
      key: 'registry_type',
      sort_key: 'registry_type',
      sortable: true,
      label: 'Registry',
    },
    {
      id: 'attributes.port_of_registry',
      key: 'attributes.port_of_registry',
      sort_key: 'port_of_registry',
      sortable: true,
      label: 'Port of Registry',
    },
    {
      id: 'attributes.id_flag.data.attributes.locality_flag',
      key: 'locality_flag',
      sort_key: 'id_flag.locality_flag',
      sortable: true,
      label: 'Flag',
    },
    {
      id: 'attributes.date_submit_signature',
      key: 'date_submit_signature',
      sort_key: 'date_submit_signature',
      sortable: true,
      label: 'Registration date',
    },
    {
      id: 'attributes.registration_status',
      key: 'registration_status',
      sort_key: 'registration_status',
      sortable: true,
      label: 'REGISTRATION STATUS',
    },
    {
      id: 'attributes',
      key: 'consents',
      sort_key: 'consents',
      sortable: false,
      label: 'Terms & Conditions',
      width: 200,
      maxWidth: 200,
    },
  ],
  render: {
    formatHead: (key, value) => {
      switch (key) {
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick) => {
      switch (key) {
        case 'date_submit_signature':
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CalendarIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value ? moment(value).format('DD/MM/YYYY') : '-'}
              </MuiTypography>
            </Stack>
          );
        case 'id': {
          return (
            <MuiTypography
              sx={{ fontWeight: 'bold', height: 1 }}
              variant='body1'
              onClick={onClick}
            >
              {value || '-'}
            </MuiTypography>
          );
        }
        case 'yacht_name': {
          return (
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              spacing={1}
            >
              <Stack direction={'column'} spacing={0.5}>
                <MuiTypography
                  sx={{ fontWeight: 'bold', height: 1 }}
                  variant='body1'
                  onClick={onClick}
                >
                  {value?.yacht_name || '-'}
                </MuiTypography>
                {value?.provenence && (
                  <MuiTypography
                    variant='caption'
                    color='text.secondary'
                    onClick={onClick}
                  >
                    {value?.provenence}
                  </MuiTypography>
                )}
              </Stack>
              <Chip label={`#${value?.id || '-'}`} size='small' />
            </Stack>
          );
        }
        case 'registration_status': {
          const color = _.find(
            RegistrationStatus,
            (item) => item.label.toUpperCase() === value.toUpperCase()
          );

          return (
            <Box onClick={onClick}>
              {value && (
                <MuiChip
                  label={value}
                  color={color?.color}
                  sx={{
                    color: color?.color ? '#fff' : color?.textHex,
                    backgroundColor: color?.hex,
                    opacity: 0.8,
                    fontWeight: 500,
                  }}
                />
              )}
            </Box>
          );
        }
        case 'consents': {
          const termsValue = value?.terms_and_condition;
          const marketingValue = value?.feedback;
          const newsletterValue = value?.commercial;
          const privacyPolicyValue = value?.privacy_policy;
          const userProfilingValue = value?.user_profiling;

          const options = [
            {
              type: 'terms',
              label: 'T&C',
              value: termsValue,
              tooltip: 'TERMS & CONDITIONS',
            },
            {
              type: 'marketing',
              label: 'MRK',
              value: marketingValue,
              tooltip: 'MARKETING',
            },
            {
              type: 'newsletter',
              label: 'NLT',
              value: newsletterValue,
              tooltip: 'NEWSLETTER',
            },
            {
              type: 'privacy',
              label: 'P&P',
              value: privacyPolicyValue,
              tooltip: 'PRIVACY POLICY',
            },
            {
              type: 'profiling',
              label: 'UP',
              value: userProfilingValue,
              tooltip: 'USER PROFILING',
            },
          ];

          return (
            <Stack direction='row' spacing={2} onClick={onClick}>
              {options.map(({ type, label, value, tooltip }, index) => {
                const config = getColorConfig(value);
                return (
                  <Tooltip key={index} title={tooltip}>
                    <Chip
                      icon={getIcon(type, value)}
                      label={label}
                      sx={{
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '2px 5px',
                        color: config.textColor,
                        borderRadius: '20px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Tooltip>
                );
              })}
            </Stack>
          );
        }
        default:
          return (
            <MuiTypography variant='body1' onClick={onClick}>
              {value ? value : '-'}
            </MuiTypography>
          );
      }
    },
  },
};
